
import { get } from "lodash";
import moment from "moment";
import React, { memo, useEffect, useState } from "react";
import { Modal, ModalBody, Table, Button, ModalHeader } from "reactstrap";

const MonthlyPaymentSchedule = memo(function MonthlyPaymentSchedule(props) {
  // console.log(">>> MonthlyPaymentSchedule", props);
  const {Coupons, units, productDetails, totalNumberCoupons} = props;

  const getPricePerUnits = (value) => (
    Number(units * value).toFixed(4)
  );
    
  return (
    <Modal
      className="payment-schedule"
      isOpen={props.showMonthlyPayment}
      toggle={props.closeMonthlyPaymentModal}
      size="lg"
    >
      <ModalHeader toggle={props.closeMonthlyPaymentModal} className="pt-3"/>
      <ModalBody>
       {
         productDetails && productDetails.couponType && (
         <div className="header">Payment Schedule</div>
        )
       }
        <div className="d-flex justify-content-center">
          <div className="header-div text-center">
            <p className="mb-1">Total Coupon Payout</p>
            <p className="mb-1"><b>{totalNumberCoupons ?
            (Number(totalNumberCoupons)).oroNumber(2, true) : "NA"}</b></p>
          </div>          
        </div>
        <Table bordered>
          <tr className="table-header">
            <td><b>Date</b></td>
            <td><b>Principal Repayment</b></td>
            <td><b>Coupon Payout</b></td>
          </tr>
          {Coupons.futureCoupons && Coupons.futureCoupons.length ? 
          Coupons.futureCoupons.map((item, index) => (
            <tr key={index}>
              <td>{moment(item['Payment Dates']).format("DD-MM-YYYY")}</td>
              <td>
                { item['principalPayoutAmount']
                  ? Number( getPricePerUnits(item['principalPayoutAmount']))
                  .oroNumber(2, true) : "₹0"
                }
              </td>
              <td>
              {item['justCoupon']
                  ? Number(getPricePerUnits(item['justCoupon'])).oroNumber(2, true)
                  : Number(getPricePerUnits(item['CouponPer1k'])).oroNumber(2, true)
                }
                </td>
              
            </tr>
          )):""}
          <tr>
            <td colspan="2" className="font-weight-semi-bold">
                <p className="mb-0 text-left">Total Coupon Payout</p>
            </td>
            <td className="font-weight-semi-bold">
                <p className="mb-0">{totalNumberCoupons ?
                (Number(totalNumberCoupons)).oroNumber(2, true) : "₹ 0"}</p>
            </td>
          </tr>
        </Table>
        <p style={{ fontSize: "10px" }}>
          Interest amount is calculated from the last interest payment date to
          the next interest date. The actual amount may differ slightly based on
          the actual date of payment <br />
          The Total Coupon Payout mentioned above excludes the Principal Amount.

        </p>
        <Button onClick={props.closeMonthlyPaymentModal}>Close</Button>
      </ModalBody>
    </Modal>
  );
});

export default MonthlyPaymentSchedule;
